<template>
<div class="kd-preview-klappkarte-quer-2">
  <div class="kd-preview-klappkarte-quer-2__sides-wrapper">
    <div class="kd-preview-klappkarte-quer-2__inner-left-and-inner-right">
      <div
        class="kd-preview-klappkarte-quer-2__side kd-preview-klappkarte-quer-2__side--inner-left"
        :style="{ backgroundImage: `url(${images['inner-left']})`}"
      ></div>
      <div
        class="kd-preview-klappkarte-quer-2__side kd-preview-klappkarte-quer-2__side--inner-right"
        :style="{ backgroundImage: `url(${images['inner-right']})`}"
      ></div>
    </div>
    <div class="kd-preview-klappkarte-quer-2__back-and-front">
      <div
        class="kd-preview-klappkarte-quer-2__side kd-preview-klappkarte-quer-2__side--back"
        :style="{ backgroundImage: `url(${images['back']})`}"
      ></div>
      <div
        class="kd-preview-klappkarte-quer-2__side kd-preview-klappkarte-quer-2__side--front"
        :style="{ backgroundImage: `url(${images['front']})`}"
      ></div>
    </div>
  </div>
</div>  
</template>

<script>
export default {
  props: {
    images: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.kd-preview-klappkarte-quer-2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
// .kd-preview-klappkarte-quer-2__sides-wrapper { transform: scale(3); }
.kd-preview-klappkarte-quer-2__back-and-front,
.kd-preview-klappkarte-quer-2__inner-left-and-inner-right { display: flex; }

.kd-preview-klappkarte-quer-2__back-and-front {
  transform: translateY(-21mm);
}
.kd-preview-klappkarte-quer-2__inner-left-and-inner-right {
  transform: scale(0.5) translateX(0%) translateY(-7%);
}
.kd-preview-klappkarte-quer-2__side {
  // width: calc(148mm / 4);
  // height: calc(105mm / 4);
  width: 148mm;
  height: 105mm;
  background-color: white;
  background-size: cover;
  // box-shadow: 0px 13px 31px 0px rgba(0,0,0,0.3);
}
.kd-preview-klappkarte-quer-2__sides-wrapper {
  transform: scale(0.8);
}
.kd-preview-klappkarte-quer-2__side--back {
  transform: perspective(300mm) rotateY(-20deg);
  transform-origin: 100% 50%;
  // background-image: url(https://lorempixel.com/800/600/abstract/);
}
.kd-preview-klappkarte-quer-2__side--front {
  transform: perspective(300mm) rotateY(20deg);
  transform-origin: 0 50%;
  // background-image: url(https://lorempixel.com/800/599/abstract/);
}
.kd-preview-klappkarte-quer-2__side--inner-left {
  transform: perspective(300mm) rotateY(20deg);
  transform-origin: 100% 50%;
  // background-image: url(https://lorempixel.com/800/598/abstract/);
}
.kd-preview-klappkarte-quer-2__side--inner-right {
  transform: perspective(300mm) rotateY(-20deg);
  transform-origin: 0 50%;
  // background-image: url(https://lorempixel.com/800/597/abstract/);
}

</style>
